import { render, staticRenderFns } from "./UserComplianceConsentAcceptance.vue?vue&type=template&id=6a99816c&scoped=true"
import script from "./UserComplianceConsentAcceptance.vue?vue&type=script&lang=js"
export * from "./UserComplianceConsentAcceptance.vue?vue&type=script&lang=js"
import style0 from "./UserComplianceConsentAcceptance.vue?vue&type=style&index=0&id=6a99816c&prod&lang=css"
import style1 from "./UserComplianceConsentAcceptance.vue?vue&type=style&index=1&id=6a99816c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a99816c",
  null
  
)

export default component.exports